import Scriba from 'react-scriba';

export class DataMotifArchivage {

    static _chargementDesMotifArchivages() {
        var url = "api/Liste/ListeDesMOTIFARCHIVAGE";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }
}